import { render, staticRenderFns } from "./Discipline.vue?vue&type=template&id=08183d98&scoped=true&"
import script from "./Discipline.vue?vue&type=script&lang=js&"
export * from "./Discipline.vue?vue&type=script&lang=js&"
import style0 from "./Discipline.vue?vue&type=style&index=0&id=08183d98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08183d98",
  null
  
)

export default component.exports